// lib/utils/freebetsApi.js
import backend from "../../server";

const FS = backend.freespin;

export const CampaignAPI = {
    listByProviderIgp: (provider, params) => FS.listCampaignByProviderIgp(provider, params),
    listByProvider: (provider, params) => FS.listCampaignByProvider(provider, params),
    createCampaign: (doc) => FS.createCampaign(doc),
    createCampaignIgp: (doc) => FS.createCampaignIgp(doc),
    addPlayerToCampaign: (campaignId, payload) => FS.addPlayerToCampaign(campaignId, payload),
    addPlayerToCampaignIgp: (campaignId, payload) => FS.addPlayerToCampaignIgp(campaignId, payload),
    cancelCampaign: (campaignId) => FS.updateStatusCampaign(campaignId, 0),
    cancelCampaignIgp: (campaignId) => FS.updateStatusCampaignIgp(campaignId, 0),
    updateCampaignStatus: (campaignId, status) => FS.updateStatusCampaign(campaignId, status),
    updateCampaignStatusIgp: (campaignId, status) => FS.updateStatusCampaignIgp(campaignId, status),
    getCampaignByCampaignId: (campaignId) => FS.getCampaignByCampaignId(campaignId),
    getCampaignByCampaignIdIgp: (campaignId) => FS.getCampaignByCampaignIdIgp(campaignId),
    updatePlayerStatus: (bonusOrId, status) => FS.updateStatusPlayer(bonusOrId, status),
};